import React from "react";
import classNames from "classnames";

type PROPS = {
  children: any
  className?: string
  multiple?: boolean
  withValidation?: boolean
}
export const FieldWrap = (props: PROPS) => {
  const {
    className = '',
    multiple,
    withValidation
  } = props;

  const cls = classNames(
    `k-form-field-wrap ${className}`,
    {
      'k-multiple': multiple,
      'k-form-field-wrap-with-validation': withValidation
    }
  );
  return(
    <div className={cls}>
      {props.children}
    </div>
  );
}